export const API_URL = process.env.REACT_APP_API_HOST
  && (process.env.REACT_APP_API_HOST.startsWith('127.0.0.1') ? `http` : `https`) +
    `://${process.env.REACT_APP_API_HOST}`

export const REACT_APP_RE_CAPTCHA_PUBLIC_KEY = process.env.REACT_APP_RE_CAPTCHA_PUBLIC_KEY
